<template>
  <div class="sub_alfx_detail">
    <header class="n-fixed-top bg-c bColor">
      <div class="left" v-if="$route.name !== 'index'" @click="back()">
        <!--<router-link to="/main/index"  class="n-back"></router-link>-->
        <div class="n-back"></div>
      </div>
      <h4>
        <span
          ><i class="over-hide">{{ subHomeworkDetailData.username }}</i
          ><i>{{ $t("sub_alfx_detail.tit_h") }}</i></span
        >
      </h4>
      <div class="right" v-if="$route.name !== 'index'"></div>
    </header>
    <div class="sub_alfx_con">
      <div class="sad-top clearfix">
        <img
          :src="
            subHomeworkDetailData.avatar
              ? subHomeworkDetailData.avatar
              : defaultHeadImg
          "
          alt=""
        />
        <div class="sad-top-name">
          <h5 class="over-hide">{{ subHomeworkDetailData.username }}</h5>
          <span class="over-hide">{{ subHomeworkDetailData.login_name }}</span>
        </div>
        <div
          class="score"
          :class="{
            pass:
              parseInt(subHomeworkDetailData.score) >=
              parseInt(subHomeworkDetailData.pass_score),
          }"
          v-if="subHomeworkDetailData.marker_uid > 0"
        >
          <div class="score_num">
            {{ subHomeworkDetailData.score }}
          </div>
          <div class="score_bg"></div>
        </div>
      </div>
      <div class="sad-top-tit">
        <h4>{{ subHomeworkDetailData.name }}</h4>
        <div class="state">
          <span class="status">
            {{ $t("sub_alfx_detail.status") }}：
            <i v-if="subHomeworkDetailData.marker_uid > 0">{{
              $t("sub_index.study_status2")
            }}</i>
            <i class="unTutor" v-else>{{ $t("sub_index.study_status1") }}</i>
          </span>
          <span
            >{{ $t("sub_alfx_detail.credits") }}：<i
              >{{ subHomeworkDetailData.credit
              }}{{ $t("sub_index.credits_d") }}</i
            ></span
          >
          <p>
            <span
              >{{ $t("sub_alfx_detail.submit_time") }}：<i>{{
                subHomeworkDetailData.created_at
              }}</i></span
            >
          </p>
        </div>
      </div>
      <div class="sad-des" v-if="subHomeworkDetailData.info != ''">
        <h6><i></i>{{ $t("sub_alfx_detail.attachment_d") }}</h6>
        <p v-html="$xss(subHomeworkDetailData.info)"></p>
      </div>
      <div class="sad-des" v-if="subHomeworkDetailData.hash != ''">
        <h6>
          <i></i>{{ $t("sub_alfx_detail.attachment_p") }}
          <p v-if="subHomeworkDetailData.file_extension == 'rar'">
            <span></span>{{ $t("sub_alfx_detail.not_support") }}
          </p>
        </h6>
        <div
          class="fujian"
          :class="{ unlook: subHomeworkDetailData.file_extension == 'rar' }"
          @click="exlook"
        >
          {{
            subHomeworkDetailData.name +
            "." +
            subHomeworkDetailData.file_extension
          }}
        </div>
      </div>
      <div class="sad-des" v-if="subHomeworkDetailData.homework_type == 1">
        <h6><i></i>{{ $t("sub_alfx_detail.attachment_s") }}</h6>
        <div class="al_submit">{{ subHomeworkDetailData.answer }}</div>
      </div>
      <div class="sad-des" v-else>
        <div class="al_no_submit">
          <div class="tit">
            {{ $t("sub_alfx_detail.attachment_s") }}
          </div>
          <p><span></span>{{ $t("sub_alfx_detail.not_support") }}</p>
        </div>
      </div>
      <div
        class="sad-des"
        v-if="
          subHomeworkDetailData.marker_uid > 0 &&
          subHomeworkDetailData.comment != ''
        "
      >
        <h6><i></i>{{ $t("sub_alfx_detail.feedback") }}</h6>
        <div class="fk">
          <b></b>
          <div class="fk_teach">
            <p>
              {{ subHomeworkDetailData.comment }}<br /><span>{{
                subHomeworkDetailData.mark_time
              }}</span>
            </p>
            <img
              :src="
                subHomeworkDetailData.leader_avatar
                  ? subHomeworkDetailData.leader_avatar
                  : defaultHeadImg
              "
              alt=""
            />
          </div>
        </div>
      </div>
      <div
        class="submit_button"
        v-if="
          subHomeworkDetailData.marker_uid == 0 &&
          subHomeworkDetailData.homework_type == 1
        "
        @click="scoreFlag = !scoreFlag"
      >
        {{ $t("sub_alfx_detail.feedback_p") }}
      </div>
    </div>

    <!--评分及反馈弹出框-->
    <div class="model_over model_xq" v-show="scoreFlag">
      <div class="model_data">
        <div class="title">
          <h6>
            {{ $t("sub_alfx_detail.feedback_p")
            }}<i @click="scoreFlag = !scoreFlag"></i>
          </h6>
        </div>
        <div class="model_con">
          <div class="pf">
            {{ $t("sub_alfx_detail.pinfen") }}：<input
              type="text"
              v-model="pfValue"
            />
            <div class="ts">
              * {{ $t("sub_alfx_detail.pass_score")
              }}{{ subHomeworkDetailData.pass_score
              }}{{ $t("sub_index.credits_d") }}
            </div>
          </div>
          <div class="fk">
            {{ $t("sub_alfx_detail.feedback") }}：<textarea
              name=""
              id=""
              v-model="commentValue"
            ></textarea>
          </div>
          <div
            class="tj"
            :class="{
              can:
                canSubmit &&
                this.commentValue.length > 0 &&
                this.commentValue.length <= 500,
            }"
            @click="submitScore"
          >
            {{ $t("sub_alfx_detail.submit") }}
          </div>
        </div>
      </div>
    </div>
    <!--提示框-->
    <div class="model model_slide" v-show="showModel">{{ modelValue }}</div>
  </div>
</template>
<script>
import defaultHeadImg from "@/assets/img/new/default.png";
export default {
  data() {
    return {
      defaultHeadImg: defaultHeadImg,
      trainplan_id: "",
      resources_id: "",
      my_sub_id: "", // 用户id
      subHomeworkDetailData: [], // 下属案例详情列表数据
      commentData: [], // 反馈评分数据
      scoreFlag: false, // 评分反馈框显隐
      pfValue: "", // 评分
      commentValue: "", // 评论
      canSubmit: false, // 能否提交 评分和提交按钮样式
      showModel: false, // 提示框
      modelValue: "", // 提示框内容
      fileUrl: "", // 文档地址
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.trainplan_id = this.$route.query.trainplan_id;
      this.resources_id = this.$route.query.resources_id;
      this.my_sub_id = this.$route.query.my_sub_id;
      this.getSubHomeworkDetailDate();
    });
  },
  methods: {
    /* 附件预览 */
    exlook() {
      if (this.subHomeworkDetailData.file_extension != "rar") {
        this.$router.push({
          name: "sub_alfx_detail_yl",
          query: {
            hash: this.subHomeworkDetailData.hash,
            file_type: this.subHomeworkDetailData.file_type,
            fileUrl: this.subHomeworkDetailData.file_url,
          },
        });
      }
    },
    getSubHomeworkDetailDate() {
      var _this = this;
      let url = "index.php/mobile/homework/my-sub-homework-info";
      let params = {
        user_id: localStorage.getItem("_user_data_id"),
        company_id: localStorage.getItem("_user_data_company_id"),
        sso_token: localStorage.getItem("_user_data_sso_token"),
        sys_id: localStorage.getItem("_sys_id"),
        language: localStorage.getItem("_user_data_language"),

        page: 1,
        size: 10,
        trainplan_id: this.trainplan_id,
        resources_id: this.resources_id,
        my_sub_id: this.my_sub_id,
      };
      this.$axios.post(url, params).then(function (res) {
        if (res.data.code == 0) {
          _this.subHomeworkDetailData = res.data.result;
          document.title =
            _this.subHomeworkDetailData.username +
            _this.$t("sub_alfx_detail.tit_h");
        }
      });
    },
    submitScore() {
      if (
        this.canSubmit &&
        this.commentValue.length > 0 &&
        this.commentValue.length <= 500
      ) {
        var _this = this;
        let url = "index.php/mobile/homework/my-sub-homework-save";
        let params = {
          user_id: localStorage.getItem("_user_data_id"),
          company_id: localStorage.getItem("_user_data_company_id"),
          sso_token: localStorage.getItem("_user_data_sso_token"),
          sys_id: localStorage.getItem("_sys_id"),
          language: localStorage.getItem("_user_data_language"),

          page: 1,
          size: 10,
          trainplan_id: this.trainplan_id,
          resources_id: this.resources_id,
          my_sub_id: this.my_sub_id,
          score: this.pfValue,
          comment: this.commentValue,
        };
        this.$axios.post(url, params).then(function (res) {
          if (res.data.code == 0) {
            _this.scoreFlag = false;
            _this.commentData = res.data.result;
            _this.getSubHomeworkDetailDate();
          }
        });
      }
    },
    back() {
      this.$router.push({
        path: "/main/sub_index/sub_homework",
        query: {
          study_status: this.$route.query.study_status,
        },
      });
    },
  },
  watch: {
    pfValue: function (cur) {
      //            console.log(cur.length);
      let num = /^[1-9]\d{0,2}$/;
      if (num.test(cur)) {
        this.canSubmit = true;
      } else {
        this.showModel = true;
        this.modelValue = this.$t("sub_alfx_detail.score");
        this.canSubmit = false;
        setTimeout(() => {
          this.showModel = false;
        }, 1000);
      }
    },
    commentValue: function (cur) {
      if (cur.length > 500) {
        this.showModel = true;
        this.modelValue = this.$t("sub_alfx_detail.over");
        setTimeout(() => {
          this.showModel = false;
        }, 1000);
      }
    },
    /* 清空反馈内容 */
    scoreFlag(cur) {
      if (!cur) {
        this.commentValue = "";
        this.pfValue = "";
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.sub_alfx_detail {
  background-color: #eee;
  .sub_alfx_con {
    padding: 0.48rem 0.56rem;
    background-color: #fff;
    @include bg-image("../../assets/img/scale/sub/zhejiao");
    background-position: top right !important;
    background-size: 10%;
    margin-top: 0.12rem;
    .sad-top {
      margin-left: 0.1rem;
      margin-bottom: 0.38rem;
      img {
        width: 1.26rem;
        height: 1.26rem;
        border-radius: 50%;
        float: left;
        margin-right: 0.18rem;
        vertical-align: middle;
      }
      .sad-top-name {
        display: inline-block;
        height: 1.26rem;
        vertical-align: middle;
        color: #252631;
        font-size: 0.3rem;
        h5 {
          margin-top: 0.1rem;
          width: 2.4rem;
        }
        span {
          display: inline-block;
          color: #7f8485;
          margin-top: 0.1rem;
          font-size: 0.2rem;
          width: 2.4rem;
        }
      }
      .score {
        display: inline-block;
        color: $unPassColor;
        text-align: right;
        vertical-align: super;
        float: right;
        margin-right: 0.84rem;
        .score_num {
          font-weight: normal;
          height: 0.8rem;
          font-size: 0.62rem;
        }
        .score_bg {
          width: 1.9rem;
          height: 0.3rem;
          @include bg-image("../../assets/img/scale/sub/unpass");
          background-size: 100%;
          background-position: center bottom;
          margin-right: -0.4rem;
        }
        &.pass {
          color: $passColor;
          .score_bg {
            width: 1.9rem;
            height: 0.3rem;
            @include bg-image("../../assets/img/scale/sub/pass");
            background-size: 100%;
            background-position: center bottom;
            margin-right: -0.4rem;
          }
        }
      }
    }
    .sad-top-tit {
      h4 {
        color: #252631;
        font-size: 0.36rem;
        margin-bottom: 0.38rem;
        font-weight: bold;
      }
      .state {
        font-size: 0.22rem;
        p {
          margin-top: 0.28rem;
          margin-bottom: 0.4rem;
        }
        span {
          display: inline-block;
          color: #252631;
          &.status {
            width: 2rem;
          }
          i {
            color: #7f8485;
            &.unTutor {
              color: $unPassColor;
            }
            &.tutor {
              color: $passColor;
            }
          }
        }
      }
    }
    .sad-des {
      padding-top: 0.38rem;
      border-top: 0.02rem solid #d9ddde;
      margin-bottom: 0.44rem;
      h6 {
        color: #252631;
        font-size: 0.3rem;
        margin-bottom: 0.28rem;
        i {
          display: inline-block;
          vertical-align: middle;
          width: 0.1rem;
          height: 0.1rem;
          border-radius: 50%;
          background-color: #000;
          margin-right: 0.2rem;
        }
        p {
          display: inline-block;
          color: $unPassColor;
          font-size: 0.22rem;
          span {
            display: inline-block;
            vertical-align: -0.04rem;
            width: 0.22rem;
            height: 0.22rem;
            @include bg-image("../../assets/img/scale/sub/warn");
            background-size: 100%;
            margin-right: 0.04rem;
          }
        }
      }
      p {
        color: #7f8485;
        font-size: 0.26rem;
      }
      .fujian {
        width: 6.24rem;
        height: 0.7rem;
        border: 1px solid $mColor;
        border-radius: 0.04rem;
        color: $mColor;
        font-size: 0.28rem;
        padding-left: 0.32rem;
        display: table-cell;
        vertical-align: middle;
        &.unlook {
          border: 1px solid #ccc;
          color: #ccc;
        }
      }
      .al_submit {
        width: 6.56rem;
        min-height: 1.36rem;
        background: rgba(238, 245, 252, 1);
        border: 1px solid $mColor;
        border-radius: 0.04rem;
        color: #7f8485;
        font-size: 0.26rem;
        padding: 0.26rem 0.28rem 0.38rem;
        box-sizing: border-box;
      }
      .al_no_submit {
        width: 6.56rem;
        height: 1.46rem;
        border: 1px solid rgba(247, 93, 93, 1);
        border-radius: 0.04rem;
        padding: 0.28rem 0.32rem;
        color: $unPassColor;
        box-sizing: border-box;
        .tit {
          font-size: 0.3rem;
          margin-bottom: 0.2rem;
          font-weight: 500;
        }
        p {
          color: $unPassColor;
          font-size: 0.22rem;
          span {
            display: inline-block;
            width: 0.22rem;
            height: 0.22rem;
            vertical-align: -0.04rem;
            @include bg-image("../../assets/img/scale/sub/warn");
            background-size: 100%;
            margin-right: 0.1rem;
          }
        }
      }
      .fk {
        width: 6.6rem;
        background-color: #f6f6f6;
        margin-top: 0.32rem;
        padding: 0.32rem 0;
        font-size: 0.2rem;
        position: relative;
        b {
          position: absolute;
          top: -0.1rem;
          left: 0.4rem;
          display: inline-block;
          width: 0.24rem;
          height: 0.24rem;
          background-color: #f6f6f6;
          transform: rotate(45deg);
        }
        .fk_teach {
          p {
            width: 4.92rem;
            min-height: 0.7rem;
            background: #fff;
            border-radius: 0.02rem;
            color: #7f8485;
            margin-left: 0.66rem;
            display: inline-block;
            padding: 0.1rem;
            box-sizing: border-box;
            span {
              display: inline-block;
              font-size: 0.16rem;
              margin-top: 0.16rem;
            }
          }
          img {
            width: 0.64rem;
            height: 0.64rem;
            border-radius: 50%;
            margin-right: 0.2rem;
            float: right;
          }
        }
      }
    }
    .submit_button {
      width: 6.64rem;
      height: 1rem;
      background: $mColor;
      border-radius: 0.1rem;
      font-size: 0.3rem;
      color: #fff;
      display: table-cell;
      vertical-align: middle;
      text-align: center;
    }
  }
  .model_over {
    /*visibility: hidden;
       */
    position: fixed;
    left: 0rem;
    top: 0rem;
    width: 100%;
    height: 100%;
    z-index: 1000;
    background-color: rgba(0, 0, 0, 0.5);
    .model_data {
      width: 6.72rem;
      /*height:7.6rem;
         */
      border-radius: 0.16rem;
      background-color: #fff;
      position: absolute;
      left: 50%;
      margin-left: -3.36rem;
      top: 2.4rem;
      .title {
        height: 0.6rem;
        line-height: 0.6rem;
        background-color: #f6f6f6;
        border-radius: 0.16rem 0.16rem 0 0;
        text-align: center;
        h6 {
          font-size: 0.24rem;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #252631;
        }
        i {
          float: right;
          display: inline-block;
          width: 0.2rem;
          height: 0.2rem;
          margin-right: 0.2rem;
          margin-top: 0.2rem;
          background: url("../../assets/img/clsicon.png") no-repeat center;
        }
      }
      .model_con {
        padding: 0.5rem;
        /*height: 7rem;
           */
        overflow: auto;
        box-sizing: border-box;
        color: #252631;
        font-size: 0.26rem;
        .pf {
          input {
            color: #7f8485;
            width: 4.76rem;
            height: 0.7rem;
            border-radius: 0.04rem;
            border: 1px solid #d9ddde;
            padding-left: 0.2rem;
            box-sizing: border-box;
          }
          .ts {
            font-size: 0.22rem;
            color: $unPassColor;
            margin: 0.1rem 0 0.3rem;
            margin-left: 0.9rem;
          }
        }
        .fk {
          textarea {
            width: 4.76rem;
            min-height: 1.4rem;
            vertical-align: top;
            border-radius: 0.04rem;
            border: 1px solid #d9ddde;
            color: #7f8485;
            padding: 0.1rem;
            box-sizing: border-box;
          }
        }
        .tj {
          color: #fff;
          width: 2.48rem;
          height: 0.76rem;
          background: rgba(217, 221, 222, 1);
          border-radius: 0.06rem;
          font-size: 0.3rem;
          text-align: center;
          /* display: table-cell;
             vertical-align: middle;
             */
          margin: 0.6rem auto;
          line-height: 0.76rem;
          &.can {
            background-color: $mColor;
          }
        }
      }
    }
  }
}
</style>
